import React, { useState } from "react";
import { Autocomplete, Box, useTheme, Checkbox, Select, CircularProgress, InputLabel, ListItemText, MenuItem, TextField, Button, Typography, } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Download } from "@mui/icons-material";
import SubHeader from "../../../../components/SubHeader";
import EmployeeList from "./EmployeeList";
import FilterPanel from "./FilterPanel";
import { useNavigate } from "react-router-dom";
import styles from "./style";
import Modal from "../../../../components/Modal";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { CustomizedRadio } from "../../../../components/CustomRadio";
import { useFormContext } from "../../../../context/FormContext";

const ManageStaffPage = ({ data, handleSearch, handleDeleteEmployee, SearchEmployee, departmentData,
  handleSort, role, permission, page, total, setPage, open, setOpen, getEmployeeList, loading, DepartmentPayroll, handleIncreament, employeeData, setGetFilterValue, getFilterVaue, employeeId, handleEmployeePdfDownload, pdfLoading,
  roleData, listFilters, handleListFiltersChange }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [model, setModel] = useState(false);
  const [rate, setRate] = useState("");
  const [error, setError] = useState("");
  const [selectedOptions, setSelectedOptions] = useState(data?.employeeDetails || []);
  const [department, setDepartment] = useState(data?.department);
  const [date, setDate] = useState(dayjs());
  const [fixed, setFixed] = useState("Fixed");
  const [increment, setincrement] = useState("true")
  const { setFormData } = useFormContext();
  const [isEmailSelected, setIsEmailSelected] = useState(false);
  const [isDepartmentSelected, setIsDepartmentSelected] = useState(false);

  const activeData = [{ label: "Active", value: "active" }, { label: "Inactive", value: "inactive" }]
  const sortOptions = [{ label: "Date", value: "date" }, { label: "Name", value: "name" }, { label: "Department", value: "department" }, { label: "Role", value: "role" }]
  const radioLabel = [{ label: "Fixed", value: "Fixed" }, { label: "Percentage", value: "Percentage" },]
  const Label = [{ label: "Increment", value: "true" }, { label: "Decrement", value: "false" },]
  const isEmployeeRole = role === "Employee" || role === "employee";
  const isAdmin = role === "Admin" || role === "admin" || role === "SuperAdmin" || role === "superadmin";

  const handleNavigate = () => {
    navigate("/dashboard/manageStaff/addNew")
    setFormData(null)
  }

  const handleChange = (event, newValue) => {
    const filteredNewValues = newValue.filter(
      (newOption) =>
        newOption?._id &&
        !selectedOptions.some((prevOption) => prevOption?._id === newOption?._id)
    );
    setSelectedOptions([...selectedOptions, ...filteredNewValues]);
  };

  const handleNavigateIncreament = () => {
    setModel(true)
  }

  const handleDepartmentChange = (e) => {
    const selectedDept = e.target.value;
    setIsDepartmentSelected(!!selectedDept)
    setDepartment(selectedDept);

    if (selectedDept === "All") {
      setSelectedOptions(employeeData);
    } else {
      DepartmentPayroll(selectedDept);

      const deptEmployees = employeeData.filter(
        (emp) => emp.personalInfo.department === selectedDept
      );
      setSelectedOptions(deptEmployees);
    }
  };

  const handleChangenwe = (e) => {
    const value = e.target.value;

    if (value === "") {
      setRate(value);
      setError("");
      return;
    }

    const regex = /^-?\d*\.?\d*$/;

    if (regex.test(value)) {
      const numValue = parseFloat(value);
      if (numValue > 0) {
        setRate(value);
        setError("");
      } else {
        setRate(value);
        setError("Please enter a positive number greater than zero.");
      }
    } else {
      setError("Please enter a valid number.");
    }
  };

  return (
    <>
      <Box
        px="15px"
        pt="20px"
        display="flex"
        alignItems="center"
        flexWrap={{ xs: "wrap", md: "nowrap" }}
        gap={"10px"}
      >
        <Typography sx={{fontSize: "22px", fontWeight: 600}}>{isEmployeeRole ? "My Employees" : "Employees"}</Typography>
        {Array.isArray(data) && data.length > 0 && (
          <Box
            display="flex"
            justifyContent={{ xs: "start", md: "end" }}
            alignItems={{ xs: "center", md: "end" }}
            flexWrap={{ xs: "wrap", md: "nowrap" }}
          >
            {(role === "Admin" || role === "SuperAdmin" || permission?.employee?.isEdit) ? (
              <Button variant="contained" onClick={handleNavigateIncreament} color="success" sx={{ borderRadius: 50, textTransform: "none", backgroundColor: "#28AA4A", fontSize: "12px", px: 3, ml: { xs: 0, md: "10px" } }}>
                Manage Rates
              </Button>
            ) : null}
          </Box>
        )}
        <Box
          display="flex"
          justifyContent={{ xs: "start", md: "end" }}
          alignItems={{ xs: "center", md: "end" }}
          flexWrap={{ xs: "wrap", md: "nowrap" }}
        >
          {(role === "Admin" || role === "SuperAdmin" || permission?.employee?.isEdit) ? (
            <Button variant="contained" onClick={handleNavigate} color="success" sx={{ borderRadius: 50, textTransform: "none", backgroundColor: "#28AA4A", ml: { xs: 0, md: "10px" } }}>
              <Typography sx={{ ml: 1, fontSize: "12px", fontWeight: 500 }}> Add New</Typography>
            </Button>
          ) : null}
          {isAdmin ? (
            <LoadingButton
              variant="outlined"
              onClick={handleEmployeePdfDownload}
              loading={pdfLoading}
              loadingPosition="start"
              startIcon={<Download />}
              sx={styles.exportBtn}
            >
              Export Pdf
            </LoadingButton>
          ) : null}
        </Box>
      </Box>
      <Box sx={{ backgroundColor: theme.palette.white.main, m: 2, borderRadius: "20px" }}>
        <SubHeader
          isShow={true}
          isShowFilter={true}
          onchange={handleSearch}
          onCompanyChange={getEmployeeList}
          onClick={handleNavigate}
          onClick2={handleNavigateIncreament}
          link={"addNew"}
          getFilterVaue={getFilterVaue}
          filterData={activeData}
          setGetFilterValue={setGetFilterValue}
          btn={permission?.employee?.isEdit || role === "Admin" || role === "SuperAdmin"}
          btn2={permission?.employee?.isEdit || role === "Admin" || role === "SuperAdmin"}
          search={permission?.employee?.isEdit || role === "Admin" || role === "SuperAdmin"}
          sortBy={permission?.employee?.isEdit || role === "Admin" || role === "SuperAdmin"}
          sortOptions={sortOptions}
          filterContent={(closeFilter) => (
            <FilterPanel departmentData={departmentData} roleData={roleData} listFilters={listFilters} onApply={handleListFiltersChange} onClose={closeFilter} />
          )}
          handleSort={handleSort} />
        <EmployeeList data={data} setPage={setPage} page={page} total={total} handleDeleteEmployee={handleDeleteEmployee} permission={permission} role={role} employeeId={employeeId} open={open} setOpen={setOpen} selectedStatus={getFilterVaue} />
        <Modal open={model} setRate={setRate} setSelectedOptions={setSelectedOptions} setDepartment={setDepartment} setOpen={setModel} btnText={"Add"} disabled={!rate} title={"Rates Adjustments"}
          handleCheck={() => {
            handleIncreament(selectedOptions.map(option => option._id), rate, date, fixed, increment);
            setModel(false);
            setRate("")
            setSelectedOptions([])
            setDepartment("")
            setIsEmailSelected(false)
            setIsDepartmentSelected(false)
          }}>
          <Box sx={styles.containerInput}>
            <Box sx={{ width: "100%" }}>
              <Autocomplete
                id="autocomplete"
                multiple
                renderOption={(props, option, { selected }) => (
                  <MenuItem {...props}>
                    <Checkbox checked={selected} style={{ marginRight: 8 }} />
                    <ListItemText primary={option?.personalInfo?.email} />
                  </MenuItem>
                )}
                options={employeeData || []}
                disableCloseOnSelect
                value={selectedOptions}
                renderTags={() => null}
                getOptionLabel={(option) => option?.personalInfo?.email || ""}
                disabled={isDepartmentSelected}
                onInputChange={(event, newInputValue) => {
                  SearchEmployee(newInputValue);
                }}
                onChange={(event, newValue) => {
                  if (newValue.length === 0) {
                    setSelectedOptions([]);
                    setIsEmailSelected(false);
                    setIsDepartmentSelected(false);
                  } else {
                    handleChange(event, newValue);
                    setIsEmailSelected(!!newValue);
                  }
                }}
                renderInput={(params) => (
                  <>
                    <InputLabel sx={styles.label}>Employee Email</InputLabel>
                    <TextField
                      {...params}
                      sx={{ ...styles.modalInput, ...styles.inputSpace }}
                      variant="outlined"
                      placeholder="Enter Employee Email"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }} />
                  </>
                )} />
            </Box>


            <Box sx={{ width: "100%", mt: 1.5 }}>
              <InputLabel sx={styles.label}>Department</InputLabel>
              <Select
                value={department}
                onChange={handleDepartmentChange}
                sx={{ ...styles.modalInput, borderRadius: "8px", my: "10px" }}
                displayEmpty
                disabled={isEmailSelected}
              >
                <MenuItem disabled value="">
                  Select
                </MenuItem>
                <MenuItem value="All">All</MenuItem>
                {departmentData?.map((item, index) => (
                  <MenuItem key={index} value={item?.name} onClick={() => DepartmentPayroll(item?.name)}>
                    {item?.name}
                  </MenuItem>
                ))}
              </Select>

            </Box>
            <Box sx={{ width: "100%", mt: 1 }}>
              <InputLabel sx={styles.label}>Rate</InputLabel>
              <TextField
                value={rate}
                name="rate"
                placeholder="Enter Rate"
                onChange={handleChangenwe}
                error={!!error}
                helperText={error}
                sx={styles.modalInputs} />
            </Box>
            <Box>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <InputLabel sx={styles.label}>Date</InputLabel>
                <DatePicker
                  value={date}
                  onChange={(value) => { setDate(value); }}
                  sx={styles.dateInput}
                  shouldDisableDate={(date) => date.isBefore(dayjs(), "day")}
                  slotProps={{
                    field: {
                      readOnly: true,
                    },
                  }} />
              </LocalizationProvider>
            </Box>
            <Box sx={{ mt: 3, display: "flex", flexDirection: "column", gap: 2 }}>
              <Box>
                <CustomizedRadio
                  handleChange={(val) => setFixed(val)}
                  value={fixed}
                  radioLabel={radioLabel} />
              </Box>
              <Box>
                <CustomizedRadio
                  handleChange={(val) => setincrement(val)}
                  value={increment}
                  radioLabel={Label} />
              </Box>
            </Box>

          </Box>
        </Modal>
      </Box></>
  );
};

export default ManageStaffPage;
